import { b as addItemByForm, a as contexts } from './cart-cce84c00.js';
import { E as EVENTS } from './events-58bc9098.js';

class ProductBlockBuyButtons extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      productContainer: 'main-product-default, [js-quick-view-content]',
      detailsContainer: '.product__details',

      // Buy buttons
      buyButtons: '[js-buy-buttons]',
      addToCartButton: '[js-add-to-cart-button]',
      productForm: '[data-product-form]',

      // Sticky ATC (tema)
      stickyATC: '[js-sticky-atc]',
    };

    this.classes = {
      active: 'active',
      hasError: 'has-error',
    };
  }

  connectedCallback() {
    this.controller = new AbortController();
    const eventOptions = { signal: this.controller.signal };

    // Container prodotto
    this.productContainer = this.closest(this.selectors.productContainer);
    if (!this.productContainer) return;

    this.detailsContainer = this.productContainer.querySelector(
      this.selectors.detailsContainer
    );

    // Product form (UNICA fonte di verità)
    this.productForm = this.querySelector(this.selectors.productForm);
    if (!this.productForm) return;

    this.addToCartButton = this.querySelector(
      this.selectors.addToCartButton
    );

    // ===============================
    // ADD TO CART (AJAX + DRAWER)
    // ===============================
    this.productForm.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        event.stopPropagation();

        addItemByForm(this.productForm, contexts.productPage, this);
      },
      eventOptions
    );

    // ===============================
    // STICKY ADD TO CART (SEMPLICE)
    // ===============================
    this.initStickyATC();
  }

  // =================================
  // Sticky Add to Cart (tema)
  // =================================
  initStickyATC() {
    this.stickyATC = this.querySelector(this.selectors.stickyATC);
    if (!this.stickyATC) return;

    const buyButtons = this.querySelector(this.selectors.buyButtons);
    if (!buyButtons) return;

    // 1️⃣ Mostra lo sticky solo quando il buy button non è visibile
    this.stickyObserver = new IntersectionObserver(
      ([entry]) => {
        this.stickyATC.classList.toggle(
          this.classes.active,
          !entry.isIntersecting
        );
      },
      { threshold: 0 }
    );

    this.stickyObserver.observe(buyButtons);

    // 2️⃣ Click sticky = submit dello STESSO form
    this.stickyATC.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        this.productForm.requestSubmit();
      },
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.stickyObserver?.disconnect();
  }
}

if (!customElements.get('product-block-buy-buttons')) {
  customElements.define(
    'product-block-buy-buttons',
    ProductBlockBuyButtons
  );
}
